import { ModelBase } from 'store/model-base';

export class CmsDeviceSuspend extends ModelBase {
    public static storeName: string = 'cmsDeviceSuspend';

    public suspended: CmsSuspendInfo;
    public nonPaySuspended: CmsSuspendInfo;
    public nonSuspended: CmsSuspendInfo;
    public paymentButton: string;
    public updateCardUrl: string;
    public billingButton: string;
    public suspendButton: string;
    public cbmUpdateCardUrlSmb: string;
    public cbmUpdateCardUrlOs: string;
}
